import { definePropType } from '@park-ui/utils'
import type { iconPropType } from '@park-ui/utils'
import type { ExtractPropTypes, PropType } from 'vue'
import type { BreadcrumbItemProps } from '@park-ui/components/breadcrumb/src/breadcrumb-item'
import type { BreadcrumbProps } from '@park-ui/components/breadcrumb/src/breadcrumb'

interface DataTypes extends BreadcrumbItemProps {
  title: string
  icon: PropType<typeof iconPropType>
  size: number
}

type BreadcrumbItemTypes = ExtractPropTypes<DataTypes>

export default {
  data: {
    type: Array as PropType<Array<BreadcrumbItemTypes>>,
    default: [],
  },
  option: {
    type: Object as PropType<BreadcrumbProps>,
    default: {
      separator: '>',
      separatorIcon: '',
    },
  },
  size: {
    type: [String, Number],
    default: 14,
  },
  showBack: Boolean,
  bigSize: {
    type: definePropType<number | string>([Number, String]),
    default: 16,
  },
}
